module.exports = __webpack_public_path__ + "img/Skizze2.2ba5d8ad.jpg";